/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Save_Mock_3Inputs */

const en_cap_save_mock_3 = /** @type {(inputs: Cap_Save_Mock_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asks for a discount outside the price list`)
};

const lv_cap_save_mock_3 = /** @type {(inputs: Cap_Save_Mock_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūdz atlaidi ārpus cenrāža`)
};

/**
* | output |
* | --- |
* | "Asks for a discount outside the price list" |
*
* @param {Cap_Save_Mock_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_save_mock_3 = /** @type {((inputs?: Cap_Save_Mock_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Save_Mock_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_save_mock_3(inputs)
	return en_cap_save_mock_3(inputs)
});